import React from "react";

function NoPage() {
  return (
    <div>
      <h1 style={{ textAlign: "center", marginTop: "70px" }}>
        PAGE NOT FOUND !
      </h1>
    </div>
  );
}

export default NoPage;
